import React from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CardHeader, useTheme, Paper, Stack, Checkbox } from '@mui/material';
import { styled } from '@mui/system';
import _ from 'lodash';

const StyledTable = styled(Table)({
  minWidth: 650,
  border: '1px solid #ddd'
});

export const SelectingTable = React.forwardRef((props, ref) => {
  const theme = useTheme();
  const { data, initSelected } = props;
  const [selected, setSelected] = React.useState([]);
  React.useImperativeHandle(ref, () => ({ getTree: () => selected }));

  React.useEffect(() => {
    if (!_.isEmpty(initSelected)) {
      setSelected(JSON.parse(initSelected));
    }
  }, [initSelected]);

  const handleChangeCamp = (cellID, cellIndex) => {
    const includes = selected.includes(cellID);
    const itemsRelated = [cellID];
    data.slice(1).map(resortData => {
      resortData.map(row => {
        itemsRelated.push(row[cellIndex + 1].id);
      });
    });
    checkForAllEventsSelected(itemsRelated);

    if (!includes) {
      setSelected([...selected, ...itemsRelated]);
    } else {
      setSelected(selected.filter(item => !itemsRelated.includes(item)));
    }
  };

  const checkForAllEventsSelected = itemsRelated => {
    // Zaznaczenie/odznaczenie całej kolumny turnusu dotyczy wszystkich imprez w tabeli,
    // więc każda z nich ma zostać powiązana z tym statusem (lub odpiąć się od niego,
    // jeśli to było ostatnie odznaczenie - patrz filtrowanie w handleChangeCamp).
    data.slice(1).map(resortRow => resortRow.map(row => itemsRelated.push(row[0].id)));
  };

  const handleChangeResort = (cellID, resortRow, rowId, cellIndex) => {
    const includes = selected.includes(cellID);
    const itemsRelated = [cellID];
    if (cellIndex == 0) {
      // Oznacza to, że zaznaczyliśmy cały ośrodek - zaznaczamy wszystkie imprezy na wszystkich turnusach
      data[resortRow + 1].map(row => {
        row.map(cell => {
          itemsRelated.push(cell.id);
        });
      });
    } else {
      // Zaznaczamy wszystkie imprezy na wybranym turnusie danego ośrodka
      data[resortRow + 1].map(row => {
        itemsRelated.push(row[cellIndex].id);
      });
      checkForEventSelected(resortRow, rowId, itemsRelated, cellID, includes, cellIndex, true);
    }
    // checkforCampSelected();
    if (!includes) {
      setSelected([...selected, ...itemsRelated]);
    } else {
      setSelected(selected.filter(item => !itemsRelated.includes(item)));
    }

  };

  const handleChangeEvent = (cellID, resortRow, rowId, cellIndex) => {
    const includes = selected.includes(cellID);
    const itemsRelated = [cellID];
    if (cellIndex == 0) {
      // Zaznaczamy wszystkie turnusy tej imprezy
      data[resortRow + 1][rowId].map(cell => {
        itemsRelated.push(cell.id);
      });
    } else {
      checkForEventSelected(resortRow, rowId, itemsRelated, cellID, includes, cellIndex);
    }
    checkForResortSelected(resortRow, rowId, itemsRelated, cellID, cellIndex);
    if (!includes) {
      setSelected([...selected, ...itemsRelated]);
    } else {
      setSelected(selected.filter(item => !itemsRelated.includes(item)));
    }
  };

  const checkForEventSelected = (resortRow, rowId, itemsRelated, cellID, includes, cellIndex, multiple = false) => {
    const campCells = data[resortRow + 1][rowId].slice(1);
    const rowNodeId = data[resortRow + 1][rowId][0].id;
    if (!includes) {
      // Zaznaczamy turnus - impreza ma zostać powiązana z tym statusem, nawet jeśli to
      // tylko jeden z wielu turnusów tej imprezy (camp i event to niezależne relacje w modelu)
      if (!selected.includes(rowNodeId)) {
        itemsRelated.push(rowNodeId);
      }
    } else {
      // Odznaczamy turnus - imprezę usuwamy dopiero, gdy to był ostatni zaznaczony turnus tej imprezy
      const remainingSelectedCamps = campCells.filter(cell => cell.id != cellID && selected.includes(cell.id));
      if (remainingSelectedCamps.length == 0) {
        itemsRelated.push(rowNodeId);
      }
    }
    if (multiple) {
      // Zaznaczenie turnusu dla całego ośrodka dotyczy każdej imprezy w tym ośrodku,
      // więc wszystkie mają zostać powiązane z tym statusem (analogicznie do
      // odznaczania - patrz filtrowanie w handleChangeResort).
      itemsRelated.push(...data[resortRow + 1].map((row, k) => row[0].id));
    }
    // wyrzucamy turnus główny, odejmujemy index bo turnus zaczyna się o 1 index później
    if (includes) {
      itemsRelated.push(data[0][cellIndex - 1].id);
    } else {
      const missingSelectedCamps = _.flatten(_.reject(data.slice(0, 1).map(resortRow => resortRow.filter(cell => !selected.includes(cell.id) && cell.id != cellID)), _.isEmpty));
      const campsToPop = [];
      missingSelectedCamps.map(camp => {
        let popped = false;
        data.slice(1).map(resortRow => resortRow.map((row, rowKey) => row.slice(1).map((cell, key) => {
          if (!selected.includes(cell.id)) {
          }
          if (rowKey != 0 && key == camp.key && !selected.includes(cell.id) && itemsRelated.includes(cell.id)) {
            if (!popped) {
              campsToPop.push(camp.id);
            }
            popped = true;

          }
        })));
      });
      const campsToPush = [...missingSelectedCamps.map(cell => cell.id)];
      if (!_.isEmpty(campsToPush)) {
        itemsRelated.push(...campsToPop);
      }
    }
  };

  const checkForResortSelected = (resortRow, rowId, itemsRelated, cellID, cellIndex) => {
    const unselectedCamps = _.reject(data[resortRow + 1].slice(1).map(row => row.slice(1).filter(cell => !selected.includes(cell.id) && cell.id != cellID)), _.isEmpty);
    if (unselectedCamps.length == 0) {
      itemsRelated.push(data[resortRow + 1][0][cellIndex].id);
      itemsRelated.push(data[resortRow + 1][0][0].id);
    } else {
      itemsRelated.push(data[resortRow + 1][0][cellIndex].id);
    }

  };

  return (

    <TableContainer component={Paper}>
      <Typography variant="h6" gutterBottom color="primary">
        Tabela aktywności promocji
      </Typography>
      <StyledTable size="small">
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            {data.slice(0, 1).flat()
              .map((camp, cellId) => (
                <TableCell key={cellId}>
                  <Stack direction="row" alignItems="center">
                    <Checkbox checked={selected.filter(item => item == camp.id).length > 0} size="small" onChange={e => handleChangeCamp(camp.id, cellId)} />
                    {camp.name.slice(-4)}
                  </Stack>

                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.slice(1).map((rows, resortRow) => (
            rows.map((row, key) => (
              <Row key={key} rowId={key} row={row} resortRow={resortRow} theme={theme} selected={selected} handleChangeResort={handleChangeResort} handleChangeEvent={handleChangeEvent} />
            ))
          ))}
        </TableBody>
      </StyledTable>
    </TableContainer>

  );
});

function Row(props) {
  const { row, rowId, theme, selected, resortRow, handleChangeResort, handleChangeEvent } = props;

  return (
    <React.Fragment>
      <TableRow sx={{ backgroundColor: rowId == 0 ? theme.palette.grey[300] : null }} >
        {row.map((cell, cellId) => (
          <TableCell key={cellId} align="left">
            <Stack direction="row" alignItems="center">
              <Checkbox checked={selected.filter(item => item == cell.id).length > 0} size="small" onChange={e => rowId == 0 ? handleChangeResort(cell.id, resortRow, rowId, cellId) : handleChangeEvent(cell.id, resortRow, rowId, cellId)} />
              {cell.name}
            </Stack>

          </TableCell>
        ))}
      </TableRow>
    </React.Fragment>
  );
}
